const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const NAME_RE = /^[\p{L}\p{N}][\p{L}\p{N}\s·.'-]{0,48}[\p{L}\p{N}]$|^[\p{L}\p{N}]$/u;

export const REFERRAL_SOURCE_OPTIONS = [
  { value: "", label: "유입 경로를 선택해 주세요 *" },
  { value: "search", label: "검색 (Google, Naver 등)" },
  { value: "sns", label: "SNS (Instagram, Facebook, YouTube 등)" },
  { value: "referral", label: "지인·동료 소개" },
  { value: "existing_client", label: "기존 고객 / 재의뢰" },
  { value: "ad", label: "온·오프라인 광고" },
  { value: "portfolio", label: "포트폴리오 / 사례 보고" },
  { value: "other", label: "기타" },
];

export function validateEmail(email) {
  const value = String(email || "").trim();
  if (!value) return "이메일을 입력해 주세요.";
  if (/\s/.test(value)) return "이메일에 공백은 사용할 수 없습니다.";
  if (!EMAIL_RE.test(value)) return "올바른 이메일 형식이 아닙니다.";
  if (/\.coom\b/i.test(value)) return "이메일 도메인을 확인해 주세요. (예: naver.com)";
  return "";
}

export function validatePassword(password, { minLength = 8, requireLetter = true, requireDigit = true } = {}) {
  const value = String(password || "");
  if (!value) return "비밀번호를 입력해 주세요.";
  if (value.length < minLength) return `비밀번호는 ${minLength}자 이상이어야 합니다.`;
  if (/\s/.test(value)) return "비밀번호에 공백은 사용할 수 없습니다.";
  if (requireLetter && !/[A-Za-z]/.test(value)) return "비밀번호에 영문자를 포함해 주세요.";
  if (requireDigit && !/\d/.test(value)) return "비밀번호에 숫자를 포함해 주세요.";
  return "";
}

export function validateName(name) {
  const value = String(name || "").trim();
  if (!value) return "이름을 입력해 주세요.";
  if (value.length < 2) return "이름은 2자 이상 입력해 주세요.";
  if (value.length > 50) return "이름은 50자 이하로 입력해 주세요.";
  if (!NAME_RE.test(value)) return "이름은 한글, 영문, 숫자만 사용할 수 있습니다.";
  return "";
}

export function validateReferralSource(value) {
  if (!value) return "유입 경로를 선택해 주세요.";
  if (!REFERRAL_SOURCE_OPTIONS.some((opt) => opt.value && opt.value === value)) {
    return "유입 경로를 선택해 주세요.";
  }
  return "";
}

export function validateLoginFields({ email, password }) {
  const emailError = validateEmail(email);
  if (emailError) return emailError;
  const passwordError = validatePassword(password, { minLength: 1, requireLetter: false, requireDigit: false });
  if (passwordError) return passwordError;
  return "";
}

export function validateSignupFields({ name, email, password, referralSource }) {
  const nameError = validateName(name);
  if (nameError) return nameError;
  const emailError = validateEmail(email);
  if (emailError) return emailError;
  const passwordError = validatePassword(password);
  if (passwordError) return passwordError;
  const referralError = validateReferralSource(referralSource);
  if (referralError) return referralError;
  return "";
}

export function getLoginFieldErrors({ email, password }) {
  return {
    email: validateEmail(email),
    password: validatePassword(password, { minLength: 1, requireLetter: false, requireDigit: false }),
  };
}

export function getSignupFieldErrors({ name, email, password, referralSource }) {
  return {
    name: validateName(name),
    email: validateEmail(email),
    password: validatePassword(password),
    referralSource: validateReferralSource(referralSource),
  };
}

export function hasFieldErrors(errors) {
  return Object.values(errors).some(Boolean);
}
